(() => {
  'use strict';
  if (customElements.get('ani-initial-purchase')) return;
  class InitialPurchase extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.ani-initial-template');
      this.product = this.closest('.product-single');
      if (!this.scope || !this.product) return;
      this.config = JSON.parse(this.querySelector('[data-ani-config]').textContent);
      this.cartTotal = Number(this.dataset.cartTotal) || 0;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'es', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.shippingMoney = new Intl.NumberFormat(this.dataset.locale || 'es', {style:'currency', currency:this.dataset.currency || 'EUR', minimumFractionDigits:0, maximumFractionDigits:2});
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.product.addEventListener('change', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      // Keep the live preview visible when changing embroidery style.
      this.product.addEventListener('change', event => {
        if (event.target.closest('variant-selects')) {
          this.keepPreviewMedia = Boolean(event.target.closest('.anitials-typeface-selector')) && event.target.value !== 'SIN LETRA';
        }
      }, {signal:this.controller.signal, capture:true});
      customElements.whenDefined('product-info').then(() => {
        if (!this.isConnected) return;
        this.mediaProduct = this.closest('product-info') || this.product.querySelector('product-info');
        if (!this.mediaProduct || typeof this.mediaProduct.updateMedia !== 'function') return;
        this.originalUpdateMedia = this.mediaProduct.updateMedia;
        this.previewUpdateMedia = (...args) => {
          if (!this.keepPreviewMedia) return this.originalUpdateMedia.apply(this.mediaProduct, args);
        };
        this.mediaProduct.updateMedia = this.previewUpdateMedia;
      });
      this.product.addEventListener('click', event => {
        if (event.target.closest('.anitials-typeface-selector .anitials-size-guide-link')) this.updateTypefacePicker(true);
      }, {signal:this.controller.signal, capture:true});
      this.product.addEventListener('theme:variant:prices-updated', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.product, {childList:true, subtree:true, characterData:true});
      this.scope.addEventListener('click', event => {
        const letterPhoto = event.target.closest('[data-ani-letter-style]');
        if (letterPhoto) {
          event.preventDefault();
          const selector = this.product.querySelector('.anitials-typeface-selector');
          const input = Array.from(selector?.querySelectorAll('input[type="radio"]') || []).find(item => item.value === letterPhoto.dataset.aniLetterStyle);
          if (input && !input.disabled && !input.checked) input.click();
          requestAnimationFrame(() => {
            const target = this.product.querySelector('.anitials-typeface-selector');
            if (!target) return;
            const offset = document.querySelector('[data-site-header]')?.getBoundingClientRect().height || 80;
            window.scrollTo({top:target.getBoundingClientRect().top + window.scrollY - offset - 20, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
            const chosen = Array.from(target.querySelectorAll('input[type="radio"]')).find(item => item.value === letterPhoto.dataset.aniLetterStyle && !item.disabled);
            chosen?.focus({preventScroll:true});
          });
          return;
        }
        const trigger = event.target.closest('[data-ani-personalize], [data-ani-back], [data-ani-buy-plain]');
        if (trigger) {
          event.preventDefault();
          const target = trigger.hasAttribute('data-ani-buy-plain') ? this.product.querySelector('button[name="add"]') : (this.product.querySelector('variant-selects') || this.product.querySelector('[data-form-wrapper]'));
          if (target) {
            const offset = document.querySelector('[data-site-header]')?.getBoundingClientRect().height || 80;
            window.scrollTo({top:target.getBoundingClientRect().top + window.scrollY - offset - 20, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
            (target.matches('button') ? target : target.querySelector('input:not([type="hidden"]),button,select'))?.focus({preventScroll:true});
          }
        }
        const anchor = event.target.closest('a[href^="#ani-initial-"]');
        if (anchor) {
          const details = document.getElementById(anchor.hash.slice(1));
          if (details?.tagName === 'DETAILS') details.open = true;
        }
      }, options);
      document.addEventListener('theme:cart:close', () => this.refreshCart(), options);
      this.update();
      this.refreshCart();
      const stickyForm = this.product.querySelector('product-sticky');
      const gallery = this.product.querySelector('[data-product-single-media-slider]');
      if (stickyForm && gallery) {
        customElements.whenDefined('product-sticky').then(() => {
          if (!this.isConnected) return;
          // Images and personalization can change height after the theme's first sticky check.
          const syncSticky = () => {
            const shouldStick = matchMedia('(min-width:1024px)').matches && stickyForm.offsetHeight < gallery.offsetHeight;
            if (shouldStick !== stickyForm.classList.contains('is-sticky')) stickyForm.resizeEvents();
          };
          this.stickyResize = new ResizeObserver(syncSticky);
          this.stickyResize.observe(stickyForm);
          this.stickyResize.observe(gallery);
          window.addEventListener('resize', syncSticky, options);
          syncSticky();
        });
      }
      const reviewHost = this.scope.querySelector('.ani-initial-reviews');
      const sortReviews = () => {
        const select = reviewHost?.querySelector('.jdgm-sort-dropdown');
        if (!select || !Array.from(select.options).some(option => option.value === 'pictures_first')) return;
        this.reviewObserver?.disconnect();
        select.value = 'pictures_first';
        select.dispatchEvent(new Event('change', {bubbles:true}));
      };
      if (reviewHost) {
        this.reviewObserver = new MutationObserver(sortReviews);
        this.reviewObserver.observe(reviewHost, {subtree:true, childList:true});
        sortReviews();
      }
      const mainButton = this.product.querySelector('[data-add-to-cart]:not([data-upsell-btn])');
      if (mainButton) {
        this.intersection = new IntersectionObserver(entries => {
          this.querySelector('[data-ani-sticky]').hidden = entries[0].isIntersecting;
        }, {threshold:0});
        this.intersection.observe(mainButton);
      }
      const mountChatSpacing = () => {
        const root = document.querySelector('[data-permut-main]')?.shadowRoot;
        if (!root) return;
        this.chatStyle = root.querySelector('[data-ani-sticky-chat]');
        if (!this.chatStyle) {
          this.chatStyle = document.createElement('style');
          this.chatStyle.dataset.aniStickyChat = '';
          this.chatStyle.textContent = '.main-element:not(.open):not(.iframe):not(.mounted){bottom:calc(var(--widget-pos-bottom,20px) + var(--ani-initial-sticky-offset,0px))!important}@media(max-width:767px){.main-element:not(.open):not(.iframe):not(.mounted){width:36px!important;height:36px!important;left:10px!important}.main-element:not(.open) .omni-button{width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;box-shadow:0 2px 8px #2b334918!important}.main-element:not(.open) .omni-button svg{width:18px!important;height:18px!important}}';
          root.append(this.chatStyle);
        }
        this.chatObserver?.disconnect();
      };
      this.chatObserver = new MutationObserver(mountChatSpacing);
      this.chatObserver.observe(document.body, {childList:true});
      window.addEventListener('load', mountChatSpacing, options);
      mountChatSpacing();
      this.scope.querySelectorAll('.ani-initial-workshop-video').forEach(video => {
        this.videoObserver ||= new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting && !matchMedia('(prefers-reduced-motion:reduce)').matches) entry.target.play().catch(() => {});
          else entry.target.pause();
        }), {threshold:0.2});
        this.videoObserver.observe(video);
      });
    }
    update() {
      // Keep the selected-letter caption readable without replacing app-owned elements.
      this.product.querySelectorAll('.product-personalizer .pplr-letra > .pplrlabel').forEach(caption => {
        const walker = document.createTreeWalker(caption, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const value = node.nodeValue.replace(/\s+[-–]\s*/g, ': ');
          if (value !== node.nodeValue) node.nodeValue = value;
        }
      });
      const selected = this.product.querySelector('[data-selected-variant]');
      let variant;
      try { variant = selected ? JSON.parse(selected.textContent || 'null') : this.config.variant; } catch { return; }
      const plain = variant?.options?.includes('SIN LETRA') || false;
      this.scope.classList.toggle('ani-initial-is-plain', plain);
      this.product.querySelectorAll('variant-selects fieldset').forEach(fieldset => {
        const values = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map(input => input.value);
        const positionOnly = values.includes('CENTRO') && values.includes('LADO') && !values.includes('SIN LETRA');
        fieldset.classList.toggle('ani-plain-hide-position', plain && positionOnly);
      });
      let garmentFound = false;
      this.product.querySelectorAll('[data-product-single-media-wrapper]').forEach(slide => {
        const source = slide.querySelector('img[data-product-image]')?.getAttribute('src') || '';
        const patch = /[/]pplr_s_/i.test(source);
        slide.classList.toggle('ani-patch-media', patch);
        const firstGarment = !patch && Boolean(source) && !garmentFound;
        if (firstGarment) garmentFound = true;
        slide.classList.toggle('ani-plain-first-garment', firstGarment);
      });

      const plainInput = this.product.querySelector('input[type="radio"][value="SIN LETRA"]');
      this.scope.classList.toggle('ani-initial-has-plain', Boolean(plainInput));
      const plainLabel = plainInput?.closest('.radio__button')?.querySelector('label');
      if (plainLabel && !plainLabel.querySelector('.ani-initial-choice')) {
        const badge = document.createElement('span');
        badge.className = 'ani-initial-choice'; badge.textContent = '−10 €'; plainLabel.append(badge);
      }
      const form = this.product.querySelector('[data-product-form]');
      const button = this.product.querySelector('[data-add-to-cart]:not([data-upsell-btn])');
      const label = button?.querySelector('[data-add-to-cart-text]');
      const cuff = this.product.querySelector('[data-ani-cuff]');
      const extra = cuff?.querySelector('[data-cuff-enabled]')?.checked ? (cuff.querySelector('[data-cuff-heart]')?.value === 'Con' ? 1500 : 1100) : 0;
      const quantity = Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value) || 1);
      const total = variant ? (Number(variant.price) + extra) * quantity : 0;
      const available = variant?.available && !this.product.hasAttribute('data-preorder-type-product');
      button?.classList.toggle('ani-initial-button-enhanced', Boolean(available));
      if (available && label) {
        const textNode = Array.from(label.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        const addText = plain ? ({es:'AÑADIR AL CARRITO',en:'ADD TO CART',de:'IN DEN WARENKORB'}[(this.dataset.locale || 'es').split('-')[0]] || 'ADD TO CART') : this.config.add;
        if (textNode && textNode.textContent !== addText) textNode.textContent = addText;
        let price = label.querySelector('[data-ani-button-total]');
        if (!price) { price = document.createElement('span'); price.dataset.aniButtonTotal = ''; label.append(price); }
        const priceText = ' · ' + this.money.format(total / 100);
        if (price.textContent !== priceText) price.textContent = priceText;
      } else label?.querySelector('[data-ani-button-total]')?.remove();
      const stickyPrice = this.querySelector('[data-ani-sticky-price]');
      const priceText = variant ? this.money.format(total / 100) : '';
      if (stickyPrice.textContent !== priceText) stickyPrice.textContent = priceText;
      const stickyImage = this.querySelector('.ani-initial-sticky-image');
      if (stickyImage && variant?.featured_image?.src) {
        const imageUrl = new URL(variant.featured_image.src, location.origin); imageUrl.searchParams.set('width','96');
        if (stickyImage.src !== imageUrl.href) { stickyImage.removeAttribute('srcset'); stickyImage.src = imageUrl.href; }
      }
      const threshold = Number(this.dataset.threshold);
      const progress = this.querySelector('[data-ani-shipping-progress]');
      const shipping = this.querySelector('[data-ani-shipping-message]');
      if (progress && shipping) {
        const remaining = Math.max(0, threshold - this.cartTotal);
        if (shipping.classList.contains('ani-initial-shipping-free') !== (remaining === 0)) shipping.classList.toggle('ani-initial-shipping-free', remaining === 0);
        const amount = this.shippingMoney.format(remaining / 100);
        const message = remaining ? this.config.remaining.replace('__amount__', amount) : this.config.free;
        if (shipping.textContent !== message || (remaining > 0 && !shipping.querySelector('strong'))) {
          if (remaining > 0) {
            const [before, after = ''] = this.config.remaining.split('__amount__');
            const strong = document.createElement('strong'); strong.textContent = amount;
            shipping.replaceChildren(document.createTextNode(before), strong, document.createTextNode(after));
          } else shipping.textContent = message;
        }
        progress.value = Math.min(threshold, this.cartTotal);
      }
      const size = this.product.querySelector('.ani-talla-spacing, .anitials-size-selector');
      if (size) {
        let note = size.querySelector('[data-ani-models]');
        if (!note) {
          note = document.createElement('p'); note.className = 'ani-initial-models'; note.dataset.aniModels = ''; note.textContent = this.config.isKids ? '' : this.config.models; size.append(note);
        }
        const fit = size.querySelector('legend .anitials-fit-inline');
        if (fit) {
          const fitText = fit.textContent.replace(/^\s*·\s*/, '').trim();
          if (fitText && !note.querySelector('.ani-initial-models-fit')) {
            const prefix = document.createElement('span'); prefix.className = 'ani-initial-models-fit'; prefix.textContent = fitText;
            note.prepend(prefix, document.createTextNode(this.config.isKids || !this.config.models ? '' : ' · '));
          }
          fit.remove();
        }
        const legend = size.querySelector('legend');
        if (legend) {
          if (matchMedia('(min-width:1024px)').matches) {
            if (note.parentElement !== legend) legend.insertBefore(note, legend.querySelector('.anitials-size-guide-link'));
          } else if (legend.nextElementSibling !== note) legend.after(note);
        }
      }
      {
        const type = this.product.querySelector('.anitials-typeface-selector');
        const mini = type?.querySelector('input[type="radio"][value="MINI"]') || type?.querySelector('input[type="radio"][value="MINI CLASSIC"]');
        const miniLabel = mini?.closest('.radio__button')?.querySelector('label');
        type?.querySelector('legend > .ani-initial-choice')?.remove();
        if (miniLabel && !miniLabel.querySelector('.ani-initial-choice')) {
          const note = document.createElement('span');
          note.className = 'ani-initial-choice';
          const chosen = this.config.chosen.toLocaleLowerCase(this.dataset.locale || 'es');
          note.textContent = chosen.charAt(0).toLocaleUpperCase(this.dataset.locale || 'es') + chosen.slice(1);
          note.title = this.config.choiceBasis;
          miniLabel.append(note);
        }
      }
      const colorLegend = this.product.querySelector('.siblings__legend');
      const colorLabel = colorLegend?.querySelector('.radio__legend__label');
      this.product.querySelector('[data-ani-color-choice]')?.remove();
      const activeSwatch = this.product.querySelector('.siblings__swatch[aria-current="true"] [data-swatch]');
      const activeColor = activeSwatch?.dataset.swatch?.trim().toLowerCase();
      const colorName = this.config.colorNames?.[activeColor] || activeSwatch?.dataset.tooltip || activeColor?.replaceAll('-', ' ');
      const colorText = this.config.colorLabel + (colorName ? ' · ' + colorName.toLocaleUpperCase(this.dataset.locale || 'es') : '');
      if (colorLabel && (colorLabel.textContent !== colorText || (colorName && !colorLabel.querySelector('.ani-initial-color-name')))) {
        colorLabel.replaceChildren(document.createTextNode(this.config.colorLabel));
        if (colorName) {
          const name = document.createElement('span'); name.className = 'ani-initial-color-name'; name.textContent = colorName.toLocaleUpperCase(this.dataset.locale || 'es');
          colorLabel.append(document.createTextNode(' · '), name);
        }
      }
      const bestsellingColor = ['navy', 'grey', 'mint', 'white', 'coral'].includes(activeColor);
      let colorBadge = colorLegend?.querySelector('[data-ani-color-badge]');
      if (bestsellingColor && colorLegend && !colorBadge) {
        colorBadge = document.createElement('span'); colorBadge.className = 'ani-initial-choice ani-initial-color-choice'; colorBadge.dataset.aniColorBadge = '';
        colorBadge.textContent = this.config.colorBestseller; colorLegend.append(colorBadge);
      } else if (!bestsellingColor) colorBadge?.remove();
      this.updateTypefacePicker();
      const cuffCopy = cuff?.querySelector('.ani-cuff__toggle > span:not(.ani-cuff__chevron)');
      if (cuffCopy) {
        const text = Array.from(cuffCopy.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
        const cuffLabel = this.config.cuffLabel + ' ';
        if (text && text.textContent !== cuffLabel) text.textContent = cuffLabel;
        const price = cuffCopy.querySelector('.ani-cuff__addon-price');
        const priceText = this.config.cuffPrice.replace('__amount__', String(extra > 0 ? extra / 100 : 11));
        if (price && price.textContent !== priceText) price.textContent = priceText;
      }
      cuff?.querySelector('.ani-initial-cuff-thumb')?.remove();
      this.product.querySelectorAll('a.siblings__link, a.siblings__button, a.siblings__swatch, .siblings__swatch a').forEach(link => {
        if (link.tagName !== 'A' || !link.hasAttribute('href')) return;
        const url = new URL(link.href, location.origin);
        if (url.origin === location.origin && url.pathname.includes('/products/')) { url.searchParams.set('view','sudaderas-inicial'); if (link.href !== url.href) link.href = url.href; }
      });
      const url = new URL(location.href);
      if (url.searchParams.get('view') !== 'sudaderas-inicial') { url.searchParams.set('view','sudaderas-inicial'); history.replaceState(history.state, '', url); }
    }
    updateTypefacePicker(loadPhotos = false) {
      const type = this.product.querySelector('.anitials-typeface-selector');
      const trigger = type?.querySelector('.anitials-size-guide-link[aria-controls]');
      const drawer = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
      const content = drawer?.querySelector('.product-popup__content');
      const inputs = Array.from(type?.querySelectorAll('input[type="radio"]') || []);
      if (!content || !inputs.length || !this.config.typefaces?.length) return;
      if (!this.typefacePicker?.isConnected || this.typefaceDrawer !== drawer) {
        const template = this.querySelector('[data-ani-typeface-picker-template]');
        if (!template) return;
        this.typefacePicker?.remove();
        this.typefaceDrawer?.classList.remove('ani-initial-typeface-guide');
        this.typefaceDrawer = drawer;
        drawer.classList.add('ani-initial-typeface-guide');
        this.typefacePicker = template.content.firstElementChild.cloneNode(true);
        const grid = this.typefacePicker.querySelector('[data-ani-typeface-options]');
        inputs.forEach(input => {
          const sample = this.config.typefaces.find(item => item.name === input.value);
          const card = document.createElement('button');
          card.type = 'button'; card.className = 'ani-typeface-option'; card.dataset.aniTypeface = input.value;
          card.setAttribute('aria-label', this.config.typefaceChoice.replace('__style__', input.value));
          if (sample?.image) {
            const photo = document.createElement('span'); photo.className = 'ani-typeface-option-photo';
            photo.setAttribute('role', 'img'); photo.setAttribute('aria-label', input.value); card.append(photo);
          }
          const name = document.createElement('span'); name.className = 'ani-typeface-option-name'; name.textContent = input.value;
          const state = document.createElement('span'); state.className = 'ani-typeface-option-state';
          card.append(name);
          if (sample?.reference) {
            const reference = document.createElement('span'); reference.className = 'ani-typeface-option-reference'; reference.textContent = this.config.typefaceReference; card.append(reference);
          }
          card.append(state); grid.append(card);
        });
        this.typefacePicker.addEventListener('click', event => {
          const card = event.target.closest('[data-ani-typeface]');
          if (!card || card.disabled) return;
          const input = Array.from(this.product.querySelectorAll('.anitials-typeface-selector input[type="radio"]')).find(item => item.value === card.dataset.aniTypeface);
          if (!input || input.disabled) return;
          input.click();
          this.updateTypefacePicker();
          if (drawer.classList.contains('is-open')) drawer.querySelector('.drawer__close-button')?.click();
        }, {signal:this.controller.signal});
        content.prepend(this.typefacePicker);
      }
      this.typefacePicker.querySelectorAll('[data-ani-typeface]').forEach(card => {
        const input = inputs.find(item => item.value === card.dataset.aniTypeface);
        card.disabled = !input || input.disabled;
        const pressed = String(Boolean(input?.checked));
        if (card.getAttribute('aria-pressed') !== pressed) card.setAttribute('aria-pressed', pressed);
        const state = card.querySelector('.ani-typeface-option-state');
        const label = input?.checked ? this.config.typefaceSelected : this.config.typefaceSelect;
        if (state.textContent !== label) state.textContent = label;
        const photo = card.querySelector('.ani-typeface-option-photo');
        if (loadPhotos && photo && !photo.style.backgroundImage) {
          const sample = this.config.typefaces.find(item => item.name === card.dataset.aniTypeface);
          photo.style.backgroundImage = 'url(' + JSON.stringify(sample.image) + ')';
        }
      });
    }
    async refreshCart() {
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart.js', {signal:this.controller.signal});
        if (!response.ok) return;
        const cart = await response.json(); this.cartTotal = Number(cart.total_price) || 0; this.schedule();
      } catch {}
    }
    disconnectedCallback() {
      if (this.mediaProduct?.updateMedia === this.previewUpdateMedia) {
        this.mediaProduct.updateMedia = this.originalUpdateMedia;
      }
      this.typefacePicker?.remove(); this.typefaceDrawer?.classList.remove('ani-initial-typeface-guide');
      this.chatObserver?.disconnect(); this.chatStyle?.remove(); this.stickyResize?.disconnect();
      this.controller?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); this.videoObserver?.disconnect(); this.reviewObserver?.disconnect(); if(this.frame) cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('ani-initial-purchase', InitialPurchase);
})();
